/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{WebSceneTag as o}from"../support/tagSymbols.js";function t(t){return null!=t&&"object"==typeof t&&o in t}export{t as isWebScene};
